import { render, staticRenderFns } from "./KnownFrom.vue?vue&type=template&id=444c5a64&scoped=true"
import script from "./KnownFrom.vue?vue&type=script&lang=js"
export * from "./KnownFrom.vue?vue&type=script&lang=js"
import style0 from "./KnownFrom.vue?vue&type=style&index=0&id=444c5a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444c5a64",
  null
  
)

export default component.exports